(function() {
    if (customElements.get('base-off-canvas') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            --off-canvas-background: white;
            --off-canvas-shadow-bg: rgba(0, 0, 0, .25);
            --off-canvas-drop-shadow: rgba(0, 0, 0, .25);
            --off-canvas-drop-shadow-offset: .5rem;
            --off-canvas-drop-shadow-size: .5rem;
            --off-canvas-transition-duration: .5s;
            --off-canvas-transition-timing-function: ease;
        
            --off-canvas-internal-shadow-offset-left: var(--off-canvas-drop-shadow-offset);
            --off-canvas-internal-shadow-offset-top: 0;
        
            position: fixed;
            z-index: 100;
            max-width: 100vw;
            max-height: 100vh;
            transition: transform var(--off-canvas-transition-duration) var(--off-canvas-transition-timing-function);
        }
        :host([shadow]) [part="shadow"] {
            position: absolute;
            z-index: 0;
            width: 1000vw;
            height: 1000vh;
            inset: -400vh -400vw;
            background: var(--off-canvas-shadow-bg);
            display: none;
            opacity: 0;
            transition: opacity var(--off-canvas-transition-duration) var(--off-canvas-transition-timing-function);
        }
        :host([shadow][open]) [part="shadow"] {
            display: block;
            opacity: 1;
        }
        [part="drop-shadow"] {
            box-shadow: var(--off-canvas-internal-shadow-offset-left) var(--off-canvas-internal-shadow-offset-top) var(--off-canvas-drop-shadow-size) var(--off-canvas-drop-shadow);
            opacity: 0;
            transition: opacity var(--off-canvas-transition-duration)  var(--off-canvas-transition-timing-function);
            position: absolute;
            inset: 0;
            z-index: 1;
        }
        :host([open]) [part="drop-shadow"] {
            opacity: 1;
        }
        [part="content"] {
            background: var(--off-canvas-background);
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 2;
            overflow: auto;
        }
        /* position = left */
        :host {
            top: 0;
            left: 0;
            bottom: 0;
            right: auto;
            width: auto;
            height: 100%;
            transform: translateX(-100%);
        }
        :host([position="right"]) {
            --off-canvas-internal-shadow-offset-left: calc(-1 * var(--off-canvas-drop-shadow-offset));
            top: 0;
            left: auto;
            bottom: 0;
            right: 0;
            width: auto;
            height: 100%;
            transform: translateX(100%);
        }
        :host([position="top"]) {
            --off-canvas-size: 25vh;
            --off-canvas-internal-shadow-offset-left: 0;
            --off-canvas-internal-shadow-offset-top: var(--off-canvas-drop-shadow-offset);
            top: 0;
            left: 0;
            bottom: auto;
            right: 0;
            width: 100%;
            height: auto;
            transform: translateY(-100%);
        }
        :host([position="bottom"]) {
            --off-canvas-size: 25vh;
            --off-canvas-internal-shadow-offset-left: 0;
            --off-canvas-internal-shadow-offset-top: calc(-1 * var(--off-canvas-drop-shadow-offset));
            top: auto;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: auto;
            transform: translateY(100%);
        }
        :host([open]) {
            transform: translate(0);
        }
        
        </style>
        <div part="drop-shadow"></div>
        <div part="shadow"></div>
        <div part="content"><slot></slot></div>
        `;
        customElements.define('base-off-canvas', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
            open() {
                if (!this.hasAttribute('open')) {
                    document.addEventListener('keyup', this.keyboardListener);
                    this.hidden = false;
                    // force re-paint before animation
                    this.offsetWidth;
                    if (this.tabIndex !== -1) {
                        this.focus();
                    }
                    this.setAttribute('open', 'open');
                    this.dispatchEvent(new CustomEvent('open', {
                        bubbles: false,
                        cancelable: false,
                    }));
                    let oepenedListener = () => {
                        if (this.getAttribute('open')) {
                            this.dispatchEvent(new CustomEvent('opened', {
                                bubbles: false,
                                cancelable: false,
                            }));
                        }
                        this.removeEventListener('transitionend', oepenedListener);
                    };
                    this.addEventListener('transitionend', oepenedListener);
                }
            }
            close() {
                if (this.hasAttribute('open')) {
                    document.removeEventListener('keyup', this.keyboardListener);
                    this.removeAttribute('open');
                    this.dispatchEvent(new CustomEvent('close', {
                        bubbles: false,
                        cancelable: false,
                    }));
                    let closedListener = () => {
                        if (!this.hasAttribute('open')) {
                            this.hidden = true;
                            this.dispatchEvent(new CustomEvent('closed', {
                                bubbles: false,
                                cancelable: false,
                            }));
                        }
                        this.removeEventListener('transitionend', closedListener);
                    };
                    this.addEventListener('transitionend', closedListener);
                }
            }
            connectedCallback() {
                this.keyboardListener = (event) => {
                    if (
                        event.code === 'Escape'
                        || event.code === 'ArrowLeft' && this.getAttribute('position') === 'left'
                        || event.code === 'ArrowRight' && this.getAttribute('position') === 'right'
                        || event.code === 'ArrowUp' && this.getAttribute('position') === 'top'
                        || event.code === 'ArrowDown' && this.getAttribute('position') === 'bottom'
                    ) {
                        this.close();
                    }
                };
                this.shadowRoot.querySelector('[part="shadow"]').addEventListener('click', () => {
                    this.close();
                });
                if (!this.hasAttribute('open')) {
                    this.hidden = true;
                }
            }
        });
    }
})();
